/**
 * Client-side Testmodus-Session (U9 + U17).
 * Persistiert über sessionStorage; serverseitige Session-ID für Leave/Reenter.
 */

export const TESTMODUS_STORAGE_KEY = "devTestbed.testmodus";

export type TestmodusSession = {
  laufId: string | null;
  schrittCode: string;
  schrittKlarname: string;
  schrittNr: number;
  prozessTitel: string;
  prozessCode?: string;
  unternehmenId: string;
  unternehmenName: string;
  productCompanyId: string | null;
  returnTo: string;
  gestartetAm: string;
  /** Serverseitige Session (U17). */
  serverSessionId?: string | null;
  gesamtlaufId?: string | null;
  probeRunId?: string | null;
  resolvedRoute?: string | null;
  zustand?: "laeuft" | "pausiert" | "verlassen";
  /** Gesamtlauf wartet auf Beurteilung (nach „Zurück und beurteilen“). */
  awaitingJudgment?: boolean;
};

export function readTestmodusSession(): TestmodusSession | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.sessionStorage.getItem(TESTMODUS_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as TestmodusSession;
    if (!parsed || typeof parsed.schrittCode !== "string") return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeTestmodusSession(session: TestmodusSession): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(TESTMODUS_STORAGE_KEY, JSON.stringify(session));
    window.dispatchEvent(new Event("dev-testbed-testmodus"));
  } catch {
    /* ignore */
  }
}

export function clearTestmodusSession(): void {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.removeItem(TESTMODUS_STORAGE_KEY);
    window.dispatchEvent(new Event("dev-testbed-testmodus"));
  } catch {
    /* ignore */
  }
}

/** Ersetzt {companyId} in Routen-Templates. */
export function resolveAnsichtRoute(
  route: string | null | undefined,
  productCompanyId: string | null,
): string | null {
  if (!route || !route.trim()) return null;
  let out = route.trim();
  if (out.includes("{companyId}")) {
    if (!productCompanyId) return null;
    out = out.split("{companyId}").join(encodeURIComponent(productCompanyId));
  }
  return out;
}
